import { Check } from 'lucide-react';
import { SEO } from '../components/SEO';
import { STATIC_SEO } from '../data/seoConfig';
import QuoteForm from '../components/QuoteForm';
import { Reveal } from '../components/Reveal';
import { SITE } from '../data/site';

const QuotePage = () => (
  <>
    <SEO
      title={STATIC_SEO.quote.title}
      description={STATIC_SEO.quote.description}
      path="/get-a-quote/"
    />
    <section className="pt-32 md:pt-40">
      <div className="container-site grid gap-14 pb-24 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="overline-label">Free Consultation</p>
            <h1 className="mt-3 font-serif text-4xl font-medium leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Get your free quote
            </h1>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-muted2">
              Tell us about your project in four quick steps. We'll follow up to schedule a free on-site consultation — no pressure, no obligation.
            </p>
            <ul className="mt-10 space-y-4">
              {[
                'Free on-site consultation at your home',
                'Custom design with transparent, itemized pricing',
                `${SITE.years}+ years serving Omaha & Lincoln`,
                `${SITE.rating} · Licensed & insured`,
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm font-medium text-ink/80">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-bronze" /> {item}
                </li>
              ))}
            </ul>
            <p className="mt-10 border-l-2 border-bronze pl-5 font-serif text-xl italic text-ink/70">
              Prefer to talk? Call us at <a href={SITE.phoneHref} data-testid="quote-page-phone" className="text-bronze underline decoration-bronze/40 underline-offset-4">{SITE.phone}</a>
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.12}>
            <QuoteForm />
          </Reveal>
        </div>
      </div>
    </section>
  </>
);

export default QuotePage;
